// Import React's Components
import React from "react";

// Import Ant Design Components
import { HourglassOutlined, SyncOutlined } from "@ant-design/icons";
import { Layout, Space, Spin } from "antd";
import { Content } from "antd/lib/layout/layout";

// CODE
export default function LoadingComponents() {
  return (
    <div className="loading">
      <Layout style={{ minHeight: "76vh", marginTop: 65 }}>
        <Content style={{ padding: 10, margin: 10 }}>
          <Space>
            <Spin
              size="large"
              tip="Please, Wait! Data is being Load..."
              indicator={<HourglassOutlined spin style={{ fontSize: 100 }} />}
              style={{ placeContent: "center", marginTop: "30vh" }}
            />
          </Space>
        </Content>
      </Layout>
    </div>
  );
}
